export default class SecondaryScraper {

  constructor(scraper = {}) {
    this.id = scraper.id || null
    this.type = scraper.type || null
    this.scraper_payload = scraper.scraper_payload || null
  }

  static mutations() {
    return {
      setScraper: (state, payload) => state.secondaryScraper = new SecondaryScraper(payload),
      updateType: (state, payload) => state.secondaryScraper.type = payload,
      updateScraperPayload: (state, payload) => state.secondaryScraper.scraper_payload = payload,
    }
  }

}